import { Provider } from '@angular/core';
import {
  TranslateService,
  TranslateStore,
  TranslateLoader,
  TranslateCompiler,
  TranslateParser,
  MissingTranslationHandler,
} from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { TranslateServiceRegistry } from '../models/translate-service-registry';
import { LocalizationActions } from '../store/localization.action';
import { LocalizationOptionService } from './localization-option.service';

export function translateServiceFactory(
  translateStore: TranslateStore,
  translateLoader: TranslateLoader,
  translateCompiler: TranslateCompiler,
  translateParser: TranslateParser,
  missingTranslationHandler: MissingTranslationHandler,
  localizationOptionService: LocalizationOptionService,
  translateServiceRegistry: TranslateServiceRegistry,
  store: Store,
) {
  const service = new TranslateService(
    translateStore,
    translateLoader,
    translateCompiler,
    translateParser,
    missingTranslationHandler,
    localizationOptionService.useDefaultLang,
    localizationOptionService.isolate,
    localizationOptionService.extend,
    localizationOptionService.defaultLanguage,
  );

  translateServiceRegistry.register(service);

  store.dispatch(new LocalizationActions.LoadLanguage());

  return service;
}

export const translateFactoryProvider: Provider = {
  provide: TranslateService,
  useFactory: translateServiceFactory,
  deps: [
    TranslateStore,
    TranslateLoader,
    TranslateCompiler,
    TranslateParser,
    MissingTranslationHandler,
    LocalizationOptionService,
    TranslateServiceRegistry,
    Store,
  ],
};
